<template>
    <div>
        <Modal v-model="invoiceAccountModal.show"
            :width="600"
            :title="'编辑开票信息'">
            <Spin v-if="innerSpin"
                size="large"
                fix></Spin>
            <Row :gutter="16">
                <Col span="24">
                <Form ref="deliveryForm"
                    label-position="right"
                    :label-width="150">

                    <Row :gutter="16">
                        <Col span="24"
                            class-name="invoiceField">
                        <FormItem label="发票抬头:"
                            required>
                            <Input v-model="invoiceAccountModal.invoiceAccountBuyerName" ></Input>
                        </FormItem>
                        </Col>
                        <Col span="24"
                            class-name="invoiceField">
                        <FormItem label="统一社会信用代码:"
                            required>
                            <Input v-model="invoiceAccountModal.invoiceAccountBuyerTaxNum" ></Input>
                        </FormItem>
                        </Col>
                        <Col span="24"
                            class-name="invoiceField">
                        <FormItem label="开户银行名称:"
                            >
                            <Input v-model="invoiceAccountModal.invoiceAccountBuyerBank" ></Input>
                        </FormItem>
                        </Col>
                        <Col span="24"
                            class-name="invoiceField">
                        <FormItem label="基本开户账号:"
                            >
                            <Input v-model="invoiceAccountModal.invoiceAccountBuyerAccount" ></Input>
                        </FormItem>
                        </Col>
                        <Col span="24"
                            class-name="invoiceField">
                        <FormItem label="注册场所地址:"
                            >
                            <Input v-model="invoiceAccountModal.invoiceAccountBuyerAddress" ></Input>
                        </FormItem>
                        </Col>
                        <Col span="24"
                            class-name="invoiceField">
                        <FormItem label="注册固定电话:"
                            >
                            <Input v-model="invoiceAccountModal.invoiceAccountBuyerTel" ></Input>
                        </FormItem>
                        </Col>
                        <!-- <Col span="24"
                            class-name="invoiceField">
                        <FormItem label="营业执照:"
                            required>
                            <b-form-file @input="onSelectFile"
                                accept="image/*"
                                size="sm"
                                placeholder="未选择图片"
                                browse-text="选择"></b-form-file>
                        </FormItem>
                        </Col>

                        <Col v-if="invoiceAccountModal.tempImagePath"
                            span="24">
                        <FormItem label=" ">
                            <b-img style="width:50%"
                                center
                                :src="invoiceAccountModal.tempImagePath"></b-img>
                        </FormItem>
                        </Col> -->

                    </Row>
                </Form>
                </Col>
            </Row>

            <div slot="footer">
                <Button type="primary"
                    @click="saveInvoiceAccount()">保存</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { getInvoiceInfo, saveInvoiceInfo } from '@/api/modules/finance-management/invoice';
import axios from 'axios';
export default {
    name: "InvoiceinvoiceAccountModal",
    mounted() {
    },
    data() {
        return {
            innerSpin: false,
            invoiceAccountModal: {
                show: false,
                invoiceAccountUuid: '',
                invoiceAccountUserUuid: '',
                invoiceAccountBuyerName: '',
                invoiceAccountBuyerTaxNum: '',
                invoiceAccountBuyerBank: '',
                invoiceAccountBuyerAccount: '',
                invoiceAccountBuyerAddress: '',
                invoiceAccountBuyerTel: ''
            },
            existsAccount: true
        };
    },
    methods: {
        showModal() {
            this.invoiceAccountModal.show = true;
            this.getInvoiceAccount();
        },
        showModalByEntity(entity) {
            Object.assign(this.invoiceAccountModal, entity);
            this.invoiceAccountModal.show = true;
        },
        getInvoiceAccount() {
            this.innerSpin = true;
            getInvoiceInfo().then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    if (res.data.invoiceAccountModel) {
                        Object.assign(this.invoiceAccountModal, res.data.invoiceAccountModel);
                        if (this.invoiceAccountModal.invoiceAccountLicenseImage) {
                            let file = JSON.parse(this.invoiceAccountModal.invoiceAccountLicenseImage);
                            this.invoiceAccountModal.tempImagePath = api.fileServer + file.url;
                        }
                        else {
                            this.invoiceAccountModal.tempImagePath = '';
                        }
                        this.existsAccount = true;
                    }
                    else {
                        this.existsAccount = false;
                    }
                }
            });
        },
        saveInvoiceAccount() {
            this.innerSpin = true;
            saveInvoiceInfo(this.invoiceAccountModal).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.$Message.success("保存成功");
                    this.invoiceAccountModal.show = false;
                    this.$emit('RefreshList');
                }
            });
        },
        onSelectFile(file) {
            let param = new FormData(); // 创建form对象
            param.append('file', file, file.name); // 通过append向form对象添加数据
            let config = {
                headers: { 'Content-Type': 'multipart/form-data' }
            };
            let that = this;
            axios.post(api.uploadFileAction, param, config)
                .then(response => {
                    let res = response.data;
                    if (res.code == 0) {
                        let firstFile = res.data.fileList[0];
                        that.invoiceAccountModal.invoiceAccountLicenseImage = JSON.stringify({
                            name: firstFile.fileName,
                            url: firstFile.fileUuid
                        });
                        that.invoiceAccountModal.tempImagePath = api.fileServer + 'upload/' + firstFile.fileUuid;
                    }
                });
        }



    }

};
</script>

<style>
.invoiceField {
    height: 40px;
}
</style>


